import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacyEn10() {
  return (
    <div>
      <Heading
        type="h3"
        title={
          <>
            {`X.`}
            <br />
            {`Delivery`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`Notices concerning the relationship between the Provider and the User, in particular regarding withdrawal from the Agreement, can be delivered by post in the form of a registered letter, email or via a User account. Notices shall be delivered to the relevant contact address of the other party and shall be deemed to have been received and effective upon delivery by post, except for notice of withdrawal made by the User where withdrawal is effective if the notice is sent to the User within the withdrawal period.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={2} className={sList}>
            <li>{`A notification whose receipt was refused by the addressee, which was not collected during the storage period or which was returned as undeliverable is also considered delivered.`}</li>
            <li>{`The Contracting Parties may deliver ordinary correspondence to each other via e-mail, to the e-mail address specified in the User's User account or specified by the User in the order, resp. to the address provided on the provider's website.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacyEn10;
